/**
 * SA-1204 (spec §5): every word of the request-to-first-quote clock. A duration
 * floors, so a rounded figure never reads inside the target when the raw one is over.
 */

export const NO_QUOTE_YET = 'No quote yet'
export const SINCE_REQUEST = 'since the request'
export const FIRST_QUOTE = 'First quote'
export const AFTER_REQUEST = 'after the request'
export const QUEUE_SENT = 'first quote in'
export const QUEUE_WAITING = 'no quote'
export const MEASURE_LABEL = 'Request to first quote:'
export const WAITING_LONGEST = 'Waiting longest:'
export const NOTHING_WAITING = 'Nothing waiting'
export const NONE_VALUE = 'None'
export const NONE_NOTE = 'no first quotes this month'

const HOUR = 60
const DAY = 1440
const TWO_DAYS = 2 * DAY

/** `42 min`; under two days `1 h 20 min` (`2 h` on the hour); else `3 d 4 h` (`3 d`). */
export function durationWords(minutes: number): string {
  const total = Math.max(0, Math.floor(minutes))
  if (total < HOUR) return `${total} min`
  if (total < TWO_DAYS) {
    const h = Math.floor(total / HOUR)
    const m = total % HOUR
    return m === 0 ? `${h} h` : `${h} h ${m} min`
  }
  const days = Math.floor(total / DAY)
  const hours = Math.floor((total - days * DAY) / HOUR)
  return hours === 0 ? `${days} d` : `${days} d ${hours} h`
}

/** `the hour` at 60, a whole number of hours as `2 h`, anything else in minutes. */
export function targetWords(target: number): string {
  if (target === HOUR) return 'the hour'
  if (target > 0 && target % HOUR === 0) return `${target / HOUR} h`
  return `${target} min`
}

export const tileTitle = (target: number): string =>
  target === HOUR ? 'Inside the hour' : `Inside ${targetWords(target)}`
export const tileValue = (inside: number, sent: number): string => `${inside} of ${sent}`
export const medianNote = (minutes: number): string => `median ${durationWords(minutes)}`
export const targetTip = (target: number): string => `Target: ${targetWords(target)}`
